<!--单据合同-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search
        :data="tableFilterList(tableHead)"
        @search="dataTableSearch"
      >
        <template v-slot:next>
          <el-button
            icon="el-icon-plus"
            @click="add()"
            v-permission="['contract:add']"
            >新增</el-button
          >
          <el-button
            icon="el-icon-upload2"
            @click="contractExport()"
            >导出</el-button
          >
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :editable="false"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        border
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #contractType="{ row }">
          <div v-for="item in contractTypeItems" :key="item.id">
            <div
              v-if="
                row.contractType && row.contractType.toString() === item.value
              "
            >
              <el-tag v-if="item.value === '1'">{{ item.label }}</el-tag>
              <el-tag v-if="item.value === '2'" type="warning">{{
                item.label
              }}</el-tag>
            </div>
          </div>
        </template>
        <template #toolbar="scope">
          <el-button
            v-if="scope.row.contractType === '2' && !statusEdit(scope.row.billState)"
            type="text"
            size="mini"
            v-permission="['contract:add']"
            @click.stop="subUpdateContractType(scope.row)"
          >转为正式合同</el-button>
          <el-popover
            :ref="scope.row.id + 'b'"
            v-permission="['contract:add']"
            v-if="scope.row.billState === 2 && isAdmin"
            placement="top"
            width="180"
          >
            <p>确定要审批通过吗</p>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="$refs[scope.row.id + 'b'].doClose()"
                >取消</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="approvalContract(scope.row.id, 3)"
                >确定
              </el-button>
            </div>
            <el-button
type="text"
size="mini"
slot="reference"
              >超级审批通过</el-button
            >
          </el-popover>
          <el-button
            type="text"
            v-permission="['contract:add']"
            size="mini"
            v-if="!statusEdit(scope.row.billState)"
            @click="changeContract(scope.row)"
            >合同变更</el-button
          >
          <el-button
            type="text"
            size="mini"
            icon="el-icon-view"
            @click="view(scope.row)"
          />
          <el-button
            type="text"
            size="mini"
            icon="el-icon-edit"
            v-permission="['contract:add']"
            @click="edit(scope.row)"
            v-if="statusEdit(scope.row.billState)"
          />
          <!-- <el-popover
            v-if="statusUnAudit(scope.row.billState)"
            :ref="scope.row.id"
            placement="top"
            width="180"
          >
            <p>确定反审核该合同单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button type="primary" size="mini" @click="reject(scope.row,5)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-circle-close" slot="reference"></el-button>
          </el-popover> -->
          <!-- <el-popover
            v-if="scope.row.billState === 2"
            :ref="scope.row.id"
            placement="top"
            width="220"
          >
            <p>确定退回该合同单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
                <el-button type="primary" size="mini" @click="reject(scope.row)">退回</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-back" slot="reference"></el-button>
          </el-popover> -->
          <el-popover
            :ref="scope.row.id"
            v-if="statusEdit(scope.row.billState)"
            placement="top"
            width="180"
          >
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="$refs[scope.row.id].doClose()"
                >取消</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="subDelete(scope.row.id)"
                >确定
              </el-button>
            </div>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-delete"
              slot="reference"
            ></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>

    <drag-dialog
      :show.sync="visible"
      :title="'虚拟合同转正式合同'"
      :width="'400px'"
      :enableDrag="true"
      :close-on-click-modal="false">
      <dynamic-form
        labelWidth="96px"
        :formConfig="formConfig"
        v-model="form"
        :showBtn="false"
        ref="form">
      </dynamic-form>
      <div style="text-align: right">
        <el-popover
          placement="top"
          width="180"
          ref="formConfirm"
        >
          <p>确定转为正式合同吗？</p>
          <div style="text-align: right; margin: 0">
            <el-button
              size="mini"
              type="text"
              @click="$refs.formConfirm.doClose()"
            >取消</el-button>
            <el-button
              type="primary"
              size="mini"
              @click="handleConfirmUpdateContractType()">确定
            </el-button>
          </div>
          <el-button type="primary" slot="reference">提交</el-button>
        </el-popover>
        <el-button @click="visible = false">取消</el-button>
      </div>
    </drag-dialog>
  </div>
</template>

<script>

import "@/components/dynamic-form";
import "@/components/EditDataTable"
import DynamicSearch from "@/components/DynamicSearch"
import DataTableMixin from "@/mixins/DataTableMixin"
import DragDialog from "@/components/DragDialog"
import { deleteContractById, reviewContract, updateContractType } from "@/api/bill/contract"
import { tableSataus } from '@/views/bill/mixins/status'
import { downloadExcel } from "@/api/bill/ProjectPlan";
import initDict from "@/mixin/initDict";

export default {
  name: "ContractIndex",
  components: { DynamicSearch, DragDialog },
  mixins: [DataTableMixin, tableSataus, initDict],
  data () {
    return {
      contractTypeItems: {},
      tableHead: [
        {
          label: '合同类型',
          prop: 'contractType',
        },
        {
          label: '单据编号',
          prop: 'code',
        },
        {
          label: '合同名称',
          prop: 'name',
          query: {
            type: 'input'
          },
        },
        {
          label: '合同号',
          prop: 'businessId',
          query: {
            type: 'input'
          },
        },
        /* {
          label: '经营人',
          prop: 'personManage.name',
        }, */
        // {
        //   label: '商机所有人',
        //   prop: 'personBusiness.name',
        // },
        {
          label: '项目经理',
          prop: 'personSaleName',
          query: {
            type: 'input'
          },
        },
        // {
        //   label: '签约状态',
        //   prop: 'state',
        //   formatter: (state) => {
        //     return state === 0 ? '未签约' : '已签约'
        //   }
        // },
        {
          label: '终端客户',
          prop: 'customerMain.name',
          query: {
            type: 'input'
          },
        },
        {
          label: '签约客户',
          prop: 'customerSigning.name',
        },
        {
          label: '合同总金额',
          prop: 'totals',
        },
        {
          label: "状态",
          prop: "billState",
          formatter: (state) => {
            return this.statusName(state)
          }
        }
      ],
      visible: false,
      formConfig: {
        formItemList: [
          {
            type: 'text',
            label: '虚拟合同号',
            key: 'businessId',
            span: 24,
            disabled: true
          },
          {
            type: 'text',
            label: '正式合同号',
            key: 'contractCode',
            span: 24,
            rules: [
              { required: true, message: "正式合同号不能为空", trigger: "blur" }
            ]
          },
        ]
      },
      form: {}
    }
  },
  created () {
    this.$nextTick(() => {
      this.dataTableInit()
      // 合同类型
      this.getDict("contractType").then(res => {
        this.contractTypeItems = res.data;
      });
    });
  },
  methods: {
    changeContract (row) {
      this.$router.push({ name: "ContractChangeForm", params: { id: row.id, isEdit: 1 } })
    },
    contractExport () {
      downloadExcel('/bizContract/export', this._query, '合同')
    },
    dataTableBeforeInit () {
      this._url = "/bizContract"
      const params = { page: this.page, size: this.offset }
      this._params = Object.assign(params, this._query)
      return true
    },
    audit (data) { // 审核
      this.updata({ id: data.id, billState: 3 })
      this.$refs[data.id].doClose()
    },
    // 4 退回 5 反审核
    reject (data, status = 4) {
      this.updata({ id: data.id, billState: status })
      this.$refs[data.id].doClose()
    },
    updata (data) {
      reviewContract(data).then(res => {
        if (res.code === 200) {
          this.$notify({
            title: "操作成功",
            type: "success",
            duration: 2500
          });
          this.dataTableInit();
        }
      });
    },
    subDelete (id) {
      deleteContractById(id).then(res => {
        this.dataTableInit()
        this.$notify({
          title: "删除成功",
          type: "success",
          duration: 2500
        })
      })
    },
    subUpdateContractType (row) {
      this.visible = true
      this.form = {
        id: row.id,
        businessId: row.businessId
      }
    },
    handleConfirmUpdateContractType() {
      this.$refs.form.validate().then(() => {
        updateContractType(this.form.id, this.form).then(res => {
          this.$refs.formConfirm.doClose()
          this.visible = false
          this.dataTableInit()
          this.$notify({
            title: "操作成功",
            type: "success",
            duration: 2500
          })
        }).catch(() => {
          this.$refs.formConfirm.doClose()
        })
      })
    },
    approvalContract (id, billState) {
      const params = {};
      params.id = id;
      params.from = 'contract';
      params.billState = billState;
      reviewContract(params).then(res => {
        this.dataTableInit()
        this.$notify({
          title: "操作成功",
          type: "success",
          duration: 2500
        })
      })
    },
    edit (row) {
      this.$router.push({ name: "ContractForm", params: { id: row.id, isEdit: 1 } })
    },
    view (row) {
      this.$router.push({ name: "ContractForm", params: { id: row.id, isEdit: 0 } })
    },
    add () {
      this.$router.push({ name: "ContractForm" })
    },
  }
}
</script>
